// firebaseConfig.ts
import { initializeApp, FirebaseApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { Database, getDatabase } from "firebase/database";
import { getFirestore, Firestore } from "firebase/firestore";
// import { getStorage, FirebaseStorage } from "firebase/storage"; // if needed

// Define Firebase config type (optional, but good practice)
interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  databaseURL: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

// Firebase configuration using environment variables
const firebaseConfig: FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY as string,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN as string,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID as string,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL as string,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BACKET as string,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDERID as string,
  appId: process.env.REACT_APP_FIREBASE_APPID as string,
};

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const rtdb: Database = getDatabase(app);
// export const storage: FirebaseStorage = getStorage(app); // if needed

export default app;
